"use client";
import { useQuery } from "@tanstack/react-query";
import ProductList from "@/components/core/product-list";
import React, { useMemo } from "react";
import Typography from "@mui/material/Typography";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import CustomBreadcrumbs from "@/main/category/(components)/custom-breadcrumbs";
import { ICollectionMeta } from "@/types/general";
import { Box, Button } from "@mui/material";
import Link from "@/components/core/localized-link";
import { getRequest } from "@/utils/request";

const Special: React.FC<{ lang: string }> = ({ lang }) => {
  const { data } = useQuery({
    queryKey: ["specials"],
    queryFn: () =>
      getRequest({
        path: { name: "special" },
        lang,
      }),
  });
  const { products } = useMemo(() => {
    if (data?.success) {
      return {
        products: data.data.items,
      };
    }
    return {
      products: [],
    };
  }, [data]);

  const meta: ICollectionMeta = {
    total_products: products.length,
    total_pages: 1,
    sort: "default",
    order: "asc",
    current_page: 1,
    page_size: 10,
  };

  return (
    <>
      <CustomBreadcrumbs crumbs={[{ title: t`Special Offers`, link: "/special" }]} />
      <Typography sx={{ fontWeight: 500, fontSize: "20px", mb: "15px" }}>
        <Trans>Special Offers</Trans>
      </Typography>
      {products?.length === 0 && (
        <Box
          sx={{
            gridColumn: { xs: "span 12", sm: "span 12" },
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            minHeight: "600px",
          }}
        >
          <Typography sx={{ fontSize: "14px", margin: "0 0 10px" }}>
            <Trans>There are no special offer products to list.</Trans>
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            <Link prefetch={false} style={{ textDecoration: "none" }} href="/">
              <Button
                sx={{
                  backgroundColor: "#0097ab",
                  color: "#fff",
                  border: "none",
                  fontSize: "14px !important",
                  borderRadius: "4px",
                  fontWeight: 400,
                  padding: "7.5px 12px",
                  transition: "0.3s ease",
                  height: "auto",
                  "&:hover": {
                    backgroundColor: "#000",
                    color: "#fff",
                  },
                }}
              >
                <Trans>Continue</Trans>
              </Button>
            </Link>
          </Box>
        </Box>
      )}
      <ProductList lang={lang} products={products} meta={meta} paging={false} />
    </>
  );
};

export default Special;
